import { decrypt } from "@/helpers/crypto-js";

const getters = {
  getUserPremiumPlanInformation: (state) => state.userPremiumPlanInformation,
  getClientPremiumPlan: (state) => state.isClientPremium,
  getUserInformation: (state) => {
    if (!Object.keys(state.user).length){
      return state.user;
    }

    return decrypt(state.user,true);
  },
  getBillingInformation: (state) => state.billing,
  getAccountClients: (state) => state.accountClients,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js